import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelXSmall} from "@khanacademy/wonder-blocks-typography";
import {publishAnalyticsEventForMinorConversion} from "@khan/analytics-learning-time";
import {useStopGuideResponse} from "@khan/guide-core";
import {GuideStateApi} from "@khan/guide-state";

export default function StopTypingButton() {
    const stopResponse = useStopGuideResponse();

    const onClick = React.useCallback(() => {
        stopResponse();

        const stopId = GuideStateApi.latest().stopId;
        if (stopId) {
            publishAnalyticsEventForMinorConversion({
                eventType: "AiGuideStopResponseClicked",
                eventSchemaVersion: 3,
                aiGuideThreadId: GuideStateApi.latest().threadId ?? "",
                aiGuideInteractionId: stopId,
                aiGuideNavigationId: GuideStateApi.latest().navigation.id,
            });
        }
    }, [stopResponse]);

    return (
        <Clickable onClick={onClick} testId="stop-typing-button">
            {() => (
                <View style={styles.stopResponse}>
                    <LabelXSmall>{t`Stop typing`}</LabelXSmall>
                </View>
            )}
        </Clickable>
    );
}

const styles = StyleSheet.create({
    stopResponse: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content",
        background: color.offWhite,
        borderRadius: 6,
        border: `1px solid ${color.offBlack16}`,
        padding: `0px ${spacing.xSmall_8}px`,
        margin: 0,
        height: 24,
        color: color.blue,
        ":hover": {
            border: `1px solid ${color.blue}`,
        },
        ":active": {
            backgroundColor: color.fadedBlue8,
        },
        ":focus": {
            border: `inset 1px solid ${color.blue}`,
        },
    },
});
